<template>
	<!-- <el-dropdown trigger="click" @command="handleLanguage">
		<span class="el-dropdown-link">
			<span class="language-size" v-if="langs[0].name === lang">{{langs[0].label}}</span>
			<span class="language-size" v-else>{{langs[1].label}}</span>
			<i class="el-icon-arrow-down el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown" class="lang-dropdown">
			<el-dropdown-item v-for="item of langs" :key="item.name" :disabled="item.name===lang" :command="item.name">
				{{item.label}}
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown> -->
	<div>
		<div style="padding:15px 20px;font-size:16px;font-weight:bold;">语言设置</div>
		<div style="padding:0px 20px;">
			<!-- <el-radio v-model="radio" label="1">中文</el-radio>
			<el-radio v-model="radio" label="2">英文</el-radio> -->
			<el-dropdown trigger="click" @command="handleLanguage">
				<el-dropdown-item v-for="item of langs" :key="item.name" :disabled="item.name===lang" :command="item.name">
					{{item.label}}
				</el-dropdown-item>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		computed: {
			...mapState('app', ['langs']),
			...mapActions('app', ['changeLang']),
			lang() {
				return this.$store.getters.lang
			}
		},
		data() {
			return {
				radio:'中文'
			};
		},
		methods: {
			handleLanguage(name) {
				// this.$i18n.locale = name;
				this.$store.dispatch('app/changeLang', name);
				this.refreshView();
				this.$message({
					message: '切换成功',
					type: 'success'
				});
			},
			refreshView() {
				// In order to make the cached page re-rendered
				this.$store.dispatch('tagsView/delAllCachedViews', this.$route)
				window.location.reload();
				// const { fullPath } = this.$route
				// console.log("---------"+fullPath)
				// this.$nextTick(() => {
				//   this.$router.replace({
				//     path: '/redirect' + fullPath
				//   })
				// })
			}
		}
	}
</script>

<style scoped>
.el-dropdown{
	width:100%;
	text-align:center;

}
.el-dropdown-menu__item{
	    margin: 10px 0px;
	background-color:#F4F4F5;
}
</style>
